import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import { Provider } from 'react-redux';

import Image from '../OC/oc-image';
import Section from '../OC/oc-section';
import { store } from '../Store';
import { connectLocation } from '../location/LocationConnectors';

const StyledImage = styled(Image)`
  display: inline-block;
  margin-bottom: 1em;
  max-width: 100%;
  position: relative;
`;

const ProductInfo = connectLocation(({ t }) => (
  <>
    <Section>
      <h2>{t('productinfo.p1_heading')}</h2>
      <div className="disclaimers">
        <p>{t('productinfo.p1_disclaimer')}</p>
      </div>
    </Section>

    <Section>
      <h2 className="body-font">{t('productinfo.p2_heading')}</h2>
      <p>{t('productinfo.p2')}</p>

      <p>{t('productinfo.p3')}</p>

      <div className="oc-table-responsive">
        <table className="oc-table full-border table-striped">
          <thead>
            <tr>
              {t('productinfo.table1.headings').map((heading, index) => (
                <th key={index}>{heading.th}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {t('productinfo.table1.row1').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>

            <tr>
              {t('productinfo.table1.row2').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </Section>

    <Section>
      <h2 className="body-font">{t('productinfo.p4_heading')}</h2>
      <p>{t('productinfo.p4')}</p>

      <div className="oc-table-responsive">
        <table className="oc-table full-border table-striped">
          <thead>
            <tr>
              {t('productinfo.table2.headings').map((heading, index) => (
                <th key={index}>{heading.th}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {t('productinfo.table2.row1').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>

            <tr>
              {t('productinfo.table2.row2').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>

            <tr>
              {t('productinfo.table2.row3').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </Section>

    <Section>
      <h2 className="body-font">{t('productinfo.p5_heading')}</h2>
      <p>
        <strong>{t('productinfo.p5')}</strong>
      </p>

      <p>{t('productinfo.p6')}</p>

      <div className="oc-table-responsive">
        <table className="oc-table full-border table-striped">
          <thead>
            <tr>
              {t('productinfo.table3.headings').map((heading, index) => (
                <th key={index}>{heading.th}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {t('productinfo.table3.row1').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>

            <tr>
              {t('productinfo.table3.row2').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <ul>
        {t('productinfo.list1').map((list, index) => (
          <li key={index}>{list.li}</li>
        ))}
      </ul>

      <p>
        <strong dangerouslySetInnerHTML={{ __html: t('productinfo.p7') }} />
      </p>

      <p>{t('productinfo.p8')}</p>

      {!t('productinfo.p9')?.startsWith('MISSING') && <p>{t('productinfo.p9')}</p>}

      <StyledImage src={t('productinfo.chart_image_url')} alt={t('productinfo.chart_image_alt')} />

      <div className="oc-table-responsive">
        <table className="oc-table full-border table-striped">
          <thead>
            <tr>
              {t('productinfo.table4.headings').map((heading, index) => (
                <th key={index}>{heading.th}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {t('productinfo.table4.row1').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>

            <tr>
              {t('productinfo.table4.row2').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>

            <tr>
              {t('productinfo.table4.row3').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>

            <tr>
              {t('productinfo.table4.row4').map((cell, index) => (
                <td key={index}>{cell.td}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <ul>
        {t('productinfo.list2').map((list, index) => (
          <li key={index}>{list.li}</li>
        ))}
      </ul>

      {!t('productinfo.additional_data')?.startsWith('MISSING') && (
        <p>
          <strong>{t('productinfo.additional_data')}</strong>
        </p>
      )}

      {typeof t('productinfo.disclaimers') !== 'string' && t('productinfo.disclaimers')?.length > 0 && (
        <div>
          <hr />
          {t('productinfo.disclaimers').map((disclaimer, index) => (
            <p className="small" dangerouslySetInnerHTML={{ __html: disclaimer }} key={index} />
          ))}
        </div>
      )}
    </Section>
  </>
));

const Index = () => (
  <Provider store={store}>
    <ProductInfo />
  </Provider>
);

export default Index;
